// MARK: NPM Modules
import React, { useState, useEffect } from "react";

// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
import Layout from "types/pages/about/outcomes/layout";
// MARK: Components
import PageBoundingBoxContainer from "components/common/layouts/containers/pageBoundingContainer";
import MultilineHeadline from "components/common/typography/multilineHeadline";
import Description from "components/common/typography/description";
import Form from "components/forms/contact/form";
import Divider from "components/common/dividers/identity/withBars";
import AlertBar from "components/common/alertBar";
import OutcomesGrid from "components/grids/outcomesGrid";
import BookAConsultation from "components/forms/bookConsultation";
// MARK: Functionality
import { TrackGoogleAnalyticsEvent } from "utils/google-analytics";
import PageEventCategory from "utils/google-analytics/events/pages";
import UserViewedOutcomesPage from "utils/google-analytics/events/pages/about/userViewedOutcomesPage";
// MARK: React Component
// Props
interface Props {
  layout: Layout;
}
// Component
function OutcomesLayout({ layout }: Props) {
  // Mark: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: State Variables
  const [alertBarOpacity, setAlertBarOpacity] = useState<number>(0);
  const [alertBarErrorMessage, setAlertBarErrorMessage] = useState<string>("");

  // MARK: Variables
  const { maximumBodyWidth, navigationBarHeight, margin } = styleguide;
  const { multilineHeadline, description, outcomesGrid } = layout;
  // MARK: On Load Effect
  useEffect(() => {
    // Send the analytics
    TrackGoogleAnalyticsEvent(
      PageEventCategory,
      UserViewedOutcomesPage,
      window.location.pathname
    );
  }, []);

  // MARK: Functionality
  const contactFormIncomplete = (message: string) => {
    setAlertBarErrorMessage(message);
    setAlertBarOpacity(1);
    setTimeout(() => {
      setAlertBarOpacity(0);
    }, 3000);
  };

  // MARK: Render

  return (
    <PageBoundingBoxContainer
      maximumBodyWidth={maximumBodyWidth}
      margin={margin}
      paddingTop={navigationBarHeight}
    >
      <AlertBar opacity={alertBarOpacity}>{alertBarErrorMessage}</AlertBar>
      <MultilineHeadline headlines={multilineHeadline} />
      <Description copy={description} />
      <OutcomesGrid
        listArialabel="Our Outcomes"
        ulRole="Our Outcomes list"
        liRole="Outcome"
        HTMLHeaderType={"h2"}
        items={outcomesGrid}
      />
      <Divider marginTop={margin * 2} />
      <Form
        includeHeaders={true}
        onSubmittionError={(message) => contactFormIncomplete(message)}
      />
      <BookAConsultation
        onUpdateAlertBar={(message) => contactFormIncomplete(message)}
      />
    </PageBoundingBoxContainer>
  );
}

export default OutcomesLayout;
